const cryptoJS = require("crypto-js");

// Key for encryption/decryption
const key = cryptoJS.enc.Utf8.parse(process.env.REACT_APP_CRYPTO_JS_SECRET_KEY);

// Function to encrypt Uint8Array
export const encryptUint8Array = async (plainText) => {
	let plaintextStr = await String.fromCharCode.apply(null, plainText);
	let encrypted = cryptoJS.AES.encrypt(plaintextStr, key, {
		mode: cryptoJS.mode.ECB,
		padding: cryptoJS.pad.Pkcs7,
	});
	return encrypted.toString();
};

// Function to decrypt Uint8Array
export const decryptUint8Array = async (cipherText) => {
	let decrypted = cryptoJS.AES.decrypt(cipherText, key, {
		mode: cryptoJS.mode.ECB,
		padding: cryptoJS.pad.Pkcs7,
	});
	let decryptedStr = decrypted.toString(cryptoJS.enc.Utf8);
	return new Uint8Array(decryptedStr.split("").map((c) => c.charCodeAt(0)));
};
